// ECharts图表组件国际化内容

export default {
  // 图表默认配置
  defaultTitle: "Bar Chart 示例",
  defaultSeriesName: "数据量",
  unitPrefix: "(单位：",
  unitSuffix: ")",

  // 特定单位显示
  unitTenThousandUSDT: "(单位：万 USDT)",
  unitCount: "(单位：个)",

  // 饼图相关
  monitorAddressRatio: "监控地址数占比",
  ratioSeriesName: "占比",

  // 柱状图相关
  inflowDataStatistics: "转入数据统计",
  unitTransactions: "（单位：笔）",
  unitTenThousandUSDTWithBrackets: "（单位：万 USDT）",
  totalInflowCount: "转入总笔数",
  totalInflowAmount: "转入总金额",

  // 折线图相关
  maliciousAddressTransferTrend: "恶意地址转账趋势图",
  unitTenThousandYuan: "(万元)",
  tenThousand: "万",
  squarePaymentTransaction: "四方支付交易",
  gamblingTransaction: "涉赌交易",

  // 地图相关
  caseCountLabel: "判例数量：",
  indictmentCountLabel: "[起诉书数量]",
};
